export enum PortalType {
  CLIENT_PORTAL = 'client',
  ATTORNEY_PORTAL = 'attorney'
}
